import FacilityCreateModal from './FacilityCreateModal'

export default FacilityCreateModal
